<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100">
            <h1 class="title">Tecnología. Innovación. Ingeniería.</h1>

            <br>
            <md-button class="md-just-icon md-round fb-button"
              @click="openLink('https://www.facebook.com/softultra.cl/')"><i class="fab fa-facebook"></i></md-button>
            &nbsp;
            <md-button class="md-just-icon md-round ig-button"
              @click="openLink('https://www.instagram.com/softultra.cl/')"><i class="fab fa-instagram"></i></md-button>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center">
              <div style="width: 100%;">
                <img :src="logo_text" alt="Thumbnail Image" class="img-logo" />
              </div>
              <br>
              <h5 class="" style="color: black;">
                Softultra es una empresa de soluciones de software y servicios
                TI la cual trabaja con tecnología disruptiva, metodologías
                acorde a los tiempos, además de un equipo de trabajo profesional
                de ingenieros capacitados, lo que permite desarrollar y entregar
                proyectos escalables, mantenibles y con un alto grado de
                calidad.
                <br />
                Desde Temuco colaboramos con los proyectos, emprendimientos, procesos informáticos (TI) de
                empresas y personas. Además, somos emprendedores, estamos creando productos de innovación
                constantemente.
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div class="section" id="services">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center">
              <h2 class="title text-center text-warning">
                Hablemos de lo que ofrecemos
              </h2>
              <h5 class="description" style="color: black;">
                Cubrimos un amplia área del desarrollo de software, diseño e
                implementación TI.
              </h5>
            </div>
          </div>
          <div class="features text-center">
            <div class="md-layout">
              <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-50 md-large-size-33">
                <div class="info">
                  <div class="icon icon-warning">
                    <md-icon>web</md-icon>
                  </div>
                  <h4 class="info-title text-warning">Desarrollo Web</h4>
                  <p style="color: black;">
                    Desarrollo de paginas web básicas, complejas, a medida,
                    intranets, extranets.
                  </p>
                </div>
              </div>
              <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-50 md-large-size-33">
                <div class="info">
                  <div class="icon icon-blank">
                    <md-icon>smartphone</md-icon>
                  </div>
                  <h4 class="info-title text-blank">Desarrollo Móvil</h4>
                  <p style="color: black;">
                    Ponte al día con la tecnología, aplicaciones móviles nativas
                    o híbridas a medida.
                  </p>
                </div>
              </div>
              <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-100 md-large-size-33">
                <div class="info">
                  <div class="icon icon-danger">
                    <md-icon>people</md-icon>
                  </div>
                  <h4 class="info-title text-danger">Asesorías</h4>
                  <p style="color: black;">
                    ¿No sabes que tecnología usar, o quieres mejorar algo en
                    cuanto a TI?. Cuenta con nosotros para asesorarte.
                  </p>
                </div>
              </div>
            </div>
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-33 md-small-size-50 md-large-size-33">
                <div class="info">
                  <div class="icon icon-info">
                    <md-icon>settings_remote</md-icon>
                  </div>
                  <h4 class="info-title text-info">IoT</h4>
                  <p style="color: black;">
                    ¿Quieres introducir sensores y/o actuadores a tu
                    organización o emprendimiento?, Nuestro equipo tiene
                    experiencia en proyectos IoT.
                  </p>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-33 md-small-size-50 md-large-size-33">
                <div class="info">
                  <div class="icon icon-warning">
                    <md-icon>cloud</md-icon>
                  </div>
                  <h4 class="info-title text-warning">Asesoría Cloud (AWS)</h4>
                  <p style="color: black;">
                    Implementa tu tecnología en la nube. Tenemos ingenieros certificados en Amazon Web Services (AWS)
                  </p>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100 md-large-size-33">
                <div class="info">
                  <div class="icon icon-primary">
                    <md-icon>person_add</md-icon>
                  </div>
                  <h4 class="info-title text-primary">
                    Reclutamiento personal TI
                  </h4>
                  <p style="color: black;">
                    ¿Necesitas contratar a personal TI?. Nosotros te filtramos y
                    entregamos personal acorde a tus necesidades.
                  </p>
                  <p />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section text-center" id="team">
        <div class="container">
          <h2 class="title text-warning">Conoce nuestro equipo</h2>
          <div class="team">
            <div class="md-layout text-center">
              <div class="md-layout-item md-medium-size-33 md-small-size-50 md-large-size-33 md-xlarge-size-33">
                <div class="team-player">
                  <md-card class="md-card-plain">
                    <div class="md-layout-item md-size-60 mx-auto">
                      <img :src="teamJSilva" alt="Thumbnail Image" class="img-raised rounded-circle img-fluid" />
                    </div>
                    <h4 class="card-title">
                      Ing. Jorge Silva
                      <br />
                      <small class="card-description text-muted">Jefe de proyectos</small>
                    </h4>
                  </md-card>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-33 md-small-size-50 md-large-size-33 md-xlarge-size-33">
                <div class="team-player">
                  <md-card class="md-card-plain">
                    <div class="md-layout-item md-size-60 mx-auto">
                      <img :src="teamCValenzuela" alt="Thumbnail Image" class="img-raised rounded-circle img-fluid" />
                    </div>
                    <h4 class="card-title">
                      Ing. Carlos Valenzuela
                      <br />
                      <small class="card-description text-muted">Jefe de proyectos - Arquitecto</small>
                    </h4>
                  </md-card>
                </div>
              </div>

              <div class="md-layout-item md-medium-size-33 md-small-size-50 md-large-size-33 md-xlarge-size-33">
                <div class="team-player">
                  <md-card class="md-card-plain">
                    <div class="md-layout-item md-size-60 mx-auto">
                      <img :src="teamSGonzalez" alt="Thumbnail Image" class="img-raised rounded-circle img-fluid" />
                    </div>
                    <h4 class="card-title">
                      Ing. Sebastian Gonzalez
                      <br />
                      <small class="card-description text-muted">Líder frontend</small>
                    </h4>
                  </md-card>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-33 md-small-size-50 md-large-size-33 md-xlarge-size-33">
                <div class="team-player">
                  <md-card class="md-card-plain">
                    <div class="md-layout-item md-size-60 mx-auto">
                      <img :src="teamVEsparza" alt="Thumbnail Image" class="img-raised rounded-circle img-fluid" />
                    </div>
                    <h4 class="card-title">
                      Ing. Víctor Esparza
                      <br />
                      <small class="card-description text-muted">Fullstack JS</small>
                    </h4>
                  </md-card>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-33 md-small-size-50 md-large-size-33 md-xlarge-size-33">
                <div class="team-player">
                  <md-card class="md-card-plain">
                    <div class="md-layout-item md-size-60 mx-auto">
                      <img :src="teamGUribe" alt="Thumbnail Image" class="img-raised rounded-circle img-fluid" />
                    </div>
                    <h4 class="card-title">
                      Ing. Gabriel Uribe
                      <br />
                      <small class="card-description text-muted">Frontend</small>
                    </h4>
                  </md-card>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-33 md-small-size-50 md-large-size-33 md-xlarge-size-33">
                <div class="team-player">
                  <md-card class="md-card-plain">
                    <div class="md-layout-item md-size-60 mx-auto">
                      <img :src="teamNParra" alt="Thumbnail Image" class="img-raised rounded-circle img-fluid" />
                    </div>
                    <h4 class="card-title">
                      Ing. Nicolás Parra
                      <br />
                      <small class="card-description text-muted">Backend</small>
                    </h4>
                  </md-card>
                </div>
              </div>
            </div>
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-33 md-small-size-100 md-large-size-33"></div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100 md-large-size-33">
                <div class="team-player">
                  <md-card class="md-card-plain">
                    <div class="md-layout-item md-size-60 mx-auto">
                      <img :src="teamBSilva" alt="Thumbnail Image" class="img-raised rounded-circle img-fluid" />
                    </div>
                    <h4 class="card-title">
                      Ing. Bastián Silva
                      <br />
                      <small class="card-description text-muted">Scrum Master - Product Owner</small>
                    </h4>
                  </md-card>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100 md-large-size-33"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="section text-center" id="clients">
        <div class="container">
          <h2 class="title text-warning">Nuestros clientes</h2>
          <div class="team text-center">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-20 md-small-size-40 md-large-size-20">
                <div class="team-player">
                  <img
                    style="height: 120px !important; width: 200px !important;"
                    :src="client4_smartAraucania"
                    alt="Thumbnail Image"
                    class="rounded img-fluid"
                    width="300"
                    height="100"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="section text-center" id="portfolio">
        <div class="container">
          <h2 class="title text-warning">Portafolio</h2>
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <nav-tabs-card no-label>
                <template slot="content">
                  <md-tabs md-sync-route class="md-success" md-alignment="left">
                    <md-tab id="tab-sorpresa" md-label="Feedbacks.cl" md-icon="thumb_up_alt">
                      <div class="md-layout">
                        <div class="md-layout-item md-medium-size-33 md-small-size-100">
                          <img :src="feedbacks" alt="Feedbacks" class="img-raised rounded img-fluid" />
                        </div>
                        <div class="md-layout-item md-medium-size-66 md-small-size-100">
                          <h3 class="text-center text-primary">
                            Compra y vende con confianza en internet
                          </h3>
                          <div style="text-align: justify">
                            Feedbacks es una plataforma que nace a partir de la necesidad de hacer más seguras las
                            compras y ventas entre personas a través de internet.
                            <br>
                            - Valorar tu experiencia en la compra de miles de productos en múltiples plataformas.
                            <br>
                            - Visitar el historial de reseñas de miles de usuarios antes de comprar o vender en línea.
                            <br>
                            - Generar confianza en los demás compartiendo tu perfil verificado de Feedbacks.
                            <br>
                            - Prevenir a la comunidad reportando tus experiencias negativas.
                            <br>
                            - Buscar usuarios potencialmente fraudulentos en la Blacklist de Feedbacks.
                            <br>
                            <div class="text-center" style="text-align:center !important;">
                              <strong>Pronto APP móvil y muchas mas funcionalidades!</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </md-tab>
                    <md-tab id="tab-ultrastock" md-label="Ultrastock" md-icon="store">
                      <div class="md-layout">
                        <div class="md-layout-item md-medium-size-33 md-small-size-100">
                          <img :src="ultrastock" alt="Ultrastock" class="img-raised rounded img-fluid" />
                        </div>
                        <div class="md-layout-item md-medium-size-66 md-small-size-100">
                          <h3 class="text-center text-primary">
                            Ultrastock [WEB/ESCRITORIO]
                          </h3>
                          <p style="text-align: justify">
                            El programa Ultrastock fue creado para el control
                            optimo de stock ya sea de un negocio pequeño, como
                            grande. Cuenta con administrador de productos,
                            categorías, ingreso de stock, ingreso de salidas,
                            mermas.
                            <br />Los informes son: Ventas, ventas por vendedor,
                            comparar días, resumen de ingresos, productos con
                            menos stock, productos mas vendidos, todos entre
                            fechas. <br />Puedes vender y así actualizar tu
                            inventario en el mismo software, junto a un lector
                            de códigos de barra. Dashboard con datos
                            importantes, ganancias, ventas, etc. Administra tus
                            usuarios, como administrador, gerente o vendedor.
                            <br />
                            <a href="#" v-scroll-to="'#contact'">Contáctanos</a>
                            para mas detalles.
                          </p>
                        </div>
                      </div>
                    </md-tab>

                    <md-tab id="tab-reciclaje" md-label="Logistica y gestión de reciclaje" md-icon="local_shipping">
                      <div class="md-layout">
                        <div class="md-layout-item md-medium-size-33 md-small-size-100">
                          <img :src="reciclaje" alt="Reciclaje" class="img-raised rounded img-fluid" />
                        </div>
                        <div class="md-layout-item md-medium-size-66 md-small-size-100">
                          <h3 class="text-center text-primary">
                            Logistica y gestión de reciclaje
                          </h3>
                          <p style="text-align: justify">
                            Software de lógistica y gestión del reciclaje en las ciudades, apoyado por CORFO, el cúal
                            aporta valor a las empresas
                            que se dedican al rubro de recolección de reciclaje gracias a la tecnología en tiempo real
                            que incluye la aplicación móvil y la plataforma web de seguimiento
                            de los camiones recolectores. A esto se suma la aplicación para clientes que solicitan el
                            retiro de un tipo de reciclaje a las empresas, esto con el fin de simplificar
                            la forma en que pedían este servicio.
                            Además de un dashboard municipal o regional para conocer a las distintas empresas que
                            reciclan en el área.
                            <br />
                          </p>
                        </div>
                      </div>
                    </md-tab>

                    <md-tab id="tab-secret" md-label="Pronto 👀" md-icon="store">
                      <div class="md-layout">
                        <div class="md-layout-item md-medium-size-66 md-small-size-100">
                          <h3 class="text-center text-primary">
                            Pronto 👀
                          </h3>
                          <p style="text-align: justify">
                            Pronto una app que va a cambiar la forma en que te mueves ;)
                          </p>
                        </div>
                      </div>
                    </md-tab>


                  </md-tabs>
                </template>
              </nav-tabs-card>
            </div>
          </div>
        </div>
      </div>
      <div class="section section-contacts">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-5 md-xsmall-size-100 mx-auto"></div>
            <div class="md-layout-item md-size-40 md-xsmall-size-100 mx-auto">
              <img :src="developer" alt="Thumbnail Image" class="img-raised rounded img-fluid" />
            </div>
            <div class="md-layout-item md-size-50 md-xsmall-size-100 mx-auto text-center" style="color: black;">
              <h3 style="text-align: justify">
                <strong class="text-warning">
                  Realizamos nuestro trabajo con las mejores y últimas tecnologías del mercado. Nos adaptamos a tu
                  necesidad!
                </strong>
                <br />
                <br />Vue.js - Angular - Node.js - Laravel - Unity - Electron -
                Android Studio - Ionic - React - React Native - Lumen - Arduino - Express -
                Spring - Java - UML - Django - Mysql - Postgresql - MongoDB - AWS S3 - AWS EC2 - AWS Amplify - Route 53
                -
                Lambda - RDS - Amazon Redshift y Muchos más!
              </h3>
            </div>
            <div class="md-layout-item md-size-5 md-xsmall-size-100 mx-auto"></div>
          </div>
        </div>
      </div>
      <!-- <div class="section section-contacts" id="contact">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto">
              <h2 class="text-center title text-warning">Contáctanos!</h2>
              <h4 class="text-center description" style="color: black;">
                Contáctanos a través de redes sociales y te responderemos a la brevedad.
              </h4>
              <md-button class="md-just-icon md-round fb-button" @click="openLink('https://www.facebook.com/softultra.cl/')"><i class="fab fa-facebook"></i></md-button>
              &nbsp;
              <md-button class="md-just-icon md-round ig-button" @click="openLink('https://www.instagram.com/softultra.cl/')"><i class="fab fa-instagram"></i></md-button>
              <form class="contact-form" @submit.prevent="sendMail">
                <div class="md-layout">
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Tu Nombre</label>
                      <md-input v-model="name" type="text" required></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Tu Email</label>
                      <md-input
                        v-model="email"
                        type="email"
                        required
                      ></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Tu Teléfono</label>
                      <md-input v-model="phone" type="text"></md-input>
                    </md-field>
                  </div>
                </div>
                <md-field maxlength="5">
                  <label>Tu Mensaje</label>
                  <md-textarea v-model="message" required></md-textarea>
                </md-field>
                <div class="md-layout">
                  <div class="md-layout-item md-size-33 mx-auto text-center">
                    <md-button
                      class="md-success"
                      type="submit"
                      :disabled="disableButton"
                      >Enviar</md-button
                    >
                  </div>
                </div>
              </form>
              <div class="alert alert-success" v-if="showSuccessEmail">
                <div class="container">
                  <button
                    type="button"
                    aria-hidden="true"
                    class="close"
                    @click="event => removeNotify(event, 'alert-success')"
                  >
                    <md-icon>clear</md-icon>
                  </button>
                  <div class="alert-icon">
                    <md-icon>check</md-icon>
                  </div>

                  <b>MENSAJE ENVIADO</b> : Pronto te responderemos!
                </div>
              </div>
              <div class="alert alert-danger" v-if="showErrorEmail">
                <div class="container">
                  <button
                    type="button"
                    aria-hidden="true"
                    class="close"
                    @click="event => removeNotify(event, 'alert-danger')"
                  >
                    <md-icon>clear</md-icon>
                  </button>
                  <div class="alert-icon">
                    <md-icon>info_outline</md-icon>
                  </div>
                  <b>ERROR AL ENVIAR</b> : Cielos, hubo un error al enviar tu
                  mensaje, envianos uno directo a: softultrateam@gmail.com
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<style scoped>
.img-logo {
  width: 100%;
  height: 100%;
}

.fb-button {
  background-color: #4267B2 !important;

}

.fb-button:hover {
  background-color: #4267B2 !important;
}

.fb-button:active {
  background-color: #4267B2 !important;
}

.ig-button {
  background-color: #E1306C !important;
}

.ig-button:hover {
  background-color: #E1306C !important;
}

.ig-button:active {
  background-color: #E1306C !important;
}
</style>
<script>
import { NavTabsCard } from "@/components";
import * as emailjs from "emailjs-com";

export default {
  components: {
    NavTabsCard
  },
  bodyClass: "landing-page",
  props: {
    logo: {
      type: String,
      default: require("@/assets/img/logo.png")
    },
    logo_text: {
      type: String,
      default: require("@/assets/img/logo_name.png")
    },
    header: {
      type: String,
      default: require("@/assets/img/bg23.jpg")
    },
    teamGUribe: {
      type: String,
      default: require("@/assets/img/team/guribe.jpg")
    },
    teamJSilva: {
      type: String,
      default: require("@/assets/img/team/jsilva.jpg")
    },
    teamVEsparza: {
      type: String,
      default: require("@/assets/img/team/vesparza.jpg")
    },
    teamNParra: {
      type: String,
      default: require("@/assets/img/team/nparra.jpg")
    },
    teamCValenzuela: {
      type: String,
      default: require("@/assets/img/team/cvalenzuela.jpg")
    },
    teamBSilva: {
      type: String,
      default: require("@/assets/img/team/bsilva.jpg")
    },
    teamSGonzalez: {
      type: String,
      default: require("@/assets/img/team/sgonzalez.jpg")
    },
    client1: {
      type: String,
      default: require("@/assets/img/clients/cliente-1.jpg")
    },
    client2: {
      type: String,
      default: require("@/assets/img/clients/cliente-2.jpg")
    },
    client3: {
      type: String,
      default: require("@/assets/img/clients/cliente-3.jpg")
    },
    client4: {
      type: String,
      default: require("@/assets/img/clients/cliente-4.jpg")
    },
    client4_smartAraucania: {
      type: String,
      default: require("@/assets/img/clients/smart_araucania.png")
    },
    client5: {
      type: String,
      default: require("@/assets/img/clients/logo-termas.png")
    },
    noloolvides: {
      type: String,
      default: require("@/assets/img/portfolio/logo_noloolvides.png")
    },
    sufro: {
      type: String,
      default: require("@/assets/img/portfolio/ufro.jpg")
    },
    feedbacks: {
      type: String,
      default: require("@/assets/img/portfolio/feedbacks.png")
    },
    reciclaje: {
      type: String,
      default: require("@/assets/img/portfolio/imagen-reciclaje.png")
    },
    ultrastock: {
      type: String,
      default: require("@/assets/img/portfolio/ultrastock.png")
    },
    developer: {
      type: String,
      default: require("@/assets/img/developer.png")
    }
  },
  data() {
    return {
      name: null,
      email: null,
      message: null,
      phone: null,
      showSuccessEmail: false,
      showErrorEmail: false,
      disableButton: false
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  },
  created() {
    emailjs.init("user_gbjd7gHSGQ3kOAcqgEc9b");
  },
  methods: {
    openLink(link) {
      window.open(link);
    },
    sendMail(event) {
      this.disableButton = true;
      var template_params = {
        reply_to: this.email,
        from_name: this.name,
        message_html: this.message,
        phone: this.phone
      };

      var service_id = "default_service";
      var template_id = "template_fLAWCZ7H";
      emailjs.send(service_id, template_id, template_params).then(
        response => {
          this.showSuccessEmail = true;
          this.email = null;
          this.name = null;
          this.message = null;
          this.phone = null;
          this.disableButton = false;
        },
        err => {
          this.showErrorEmail = true;
          this.disableButton = false;
        }
      );
    },
    removeNotify(e, notifyClass) {
      var target = e.target;
      while (target.className.indexOf(notifyClass) === -1) {
        target = target.parentNode;
      }
      return target.parentNode.removeChild(target);
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}

.contact-form {
  margin-top: 30px;
}

.md-has-textarea+.md-layout {
  margin-top: 15px;
}
</style>
